import classNames from 'classnames';
import * as React from 'react';
import styles from './style.m.less';

type Props = {
    children?: React.ReactNode;
    className?: string;
    align?: 'left' | 'center' | 'right';
};

export default function ButtonContainer({ children, className, align = 'right' }: Props) {
    return <div className={classNames(styles.container, styles[`align-${align}`], className)}>{children}</div>;
}

/**
 * @deprecated Please use `ButtonContainer` for anything new.
 */
export function DeprecatedButtonContainer(
    props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
    const containerProps = {
        ...props,
        className: classNames('button-container', props.className),
    };
    return <div {...containerProps} />;
}
